import { render, staticRenderFns } from "./analysis_manbing.vue?vue&type=template&id=52558e44&scoped=true"
import script from "./analysis_manbing.vue?vue&type=script&lang=js"
export * from "./analysis_manbing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52558e44",
  null
  
)

export default component.exports